export interface Tier {
  id: number
  name: string
  /** Level numbers (1-based, inclusive). */
  from: number
  to: number
  intro: string
  mechanics: readonly ('arrows' | 'flicker' | 'crack' | 'monsters' | 'key')[]
}

export const TIERS: readonly Tier[] = [
  {
    id: 1,
    name: 'Frozen Lake',
    from: 1,
    to: 12,
    intro: 'Slide until something stops you. Holes send you back to the start.',
    mechanics: [],
  },
  {
    id: 2,
    name: 'Wind Tunnels',
    from: 13,
    to: 26,
    intro: 'Arrows shove you in a new direction mid-slide.',
    mechanics: ['arrows'],
  },
  {
    id: 3,
    name: 'Flicker Field',
    from: 27,
    to: 40,
    intro: 'Flickering rocks are solid on even moves and vanish on odd ones. Count your moves.',
    mechanics: ['arrows', 'flicker'],
  },
  {
    id: 4,
    name: 'Cracking Ice',
    from: 41,
    to: 55,
    intro: 'Cracked ice breaks after you cross it — and never stop on it.',
    mechanics: ['arrows', 'crack'],
  },
  {
    id: 5,
    name: 'Yeti Country',
    from: 56,
    to: 70,
    intro: 'Yetis patrol the ice and take one step after each of your moves. Do not touch them.',
    mechanics: ['arrows', 'monsters'],
  },
  {
    id: 6,
    name: 'Locked Doors',
    from: 71,
    to: 85,
    intro: 'The door stays shut until you have crossed the key.',
    mechanics: ['arrows', 'flicker', 'key'],
  },
  {
    id: 7,
    name: 'The Gauntlet',
    from: 86,
    to: 100,
    intro: 'Everything at once. Good luck.',
    mechanics: ['arrows', 'flicker', 'crack', 'monsters', 'key'],
  },
]

export function tierOf(levelNumber: number): Tier {
  return TIERS.find((t) => levelNumber >= t.from && levelNumber <= t.to) ?? TIERS[TIERS.length - 1]!
}
